import React, { useEffect, useState } from 'react'
import styles from './style/index.module.less'
import NavItem from './NavItem'
import VipBtn from './VipBtn'
import ChangeThemeBtn from './ChangeThemeBtn'
import Logo from './Logo'
import {
  IconHome,
  IconDocument,
  IconSmartAssistant,
  IconTemplateLibrary,
  IconDatabase,
  IconCollect,
  IconWastePaper,
  IconGuide,
  IconApplication,
  IconAiDrawing,
} from '@arco-iconbox/react-aidb-v2'
import { IconMyOrder } from '@arco-iconbox/react-aidb'
import { getUserInfo } from '@/model/reference'
import ModalCustom from '../ModalCustom'
import TemplateMod from '../templateLibrary/TemplateMod'
import SearchMod from '@/pages/intelligentDocument/SearchMod'
import request from '@/utils/request'
import IconDraw1 from '../../assets/imgs/draw1.svg'
import IconDraw2 from '../../assets/imgs/draw2.svg'
import IconDraw3 from '../../assets/imgs/draw3.svg'
import { useSelector } from 'react-redux'
import { GlobalState } from '../../store'
import { useHistory } from 'react-router-dom'
function SideNav(props) {
  const history = useHistory()
  const curIndex = props.curIndex
  // 从localStorage中获取缓存的模板数据
  const cachedTemplateData = localStorage.getItem('templateData')
  // 解析JSON数据
  const initialTemplateData = cachedTemplateData
    ? JSON.parse(cachedTemplateData)
    : null
  // 新增一个状态用于缓存模板数据
  const [templateData, setTemplateData] = useState(initialTemplateData)
  const [list, setList] = useState<any>(initialTemplateData)
  //显示弹窗
  const [visibleImg, setVisibleImg] = useState(false)
  const [visibleTem, setVisibleTem] = useState(false)
  const theme = useSelector((state: GlobalState) => state.theme)

  const navList = [
    {
      icon: <IconHome useCurrentColor={false} />,
      title: '主页',
      index: 0,
      path: '/home',
    },
    {
      icon: <IconDocument useCurrentColor={false} />,
      title: '智能文档',
      index: 1,
      path: '/intelligentDocument',
    },

    {
      icon: <IconSmartAssistant useCurrentColor={false} />,
      title: '智能助理',
      index: 3,
      path: '/toolbox/index',
    },
  ]
  const navList2 = [
    {
      icon: <IconCollect useCurrentColor={true} />,
      title: '收藏夹',
      index: 5,
      path: '/collect',
    },
    {
      icon: <IconWastePaper useCurrentColor={true} />,
      title: '废纸篓',
      index: 6,
      path: '/waste',
    },
  ]
  const navList3 = [
    {
      icon: <IconApplication useCurrentColor={true} />,
      title: '支持中心',
      index: 7,
      path: 'https://go.aidb.work/56ef',
    },
    {
      icon: <IconGuide useCurrentColor={true} />,
      title: '用户反馈',
      index: 8,
      path: 'https://ias.zgbjds.com/contact-us/',
    },
  ]

  function handleToPage(item) {
    localStorage.setItem('listIndex', item.index)
    if (item.index == 2) {
      // 检查templateData是否有数据
      if (templateData) {
        // 如果有数据，直接打开模板库弹窗，不再发起请求
        setVisibleTem(true)
      }
    } else if (item.index == 4) {
      setVisibleImg(true)
    } else {
      history.push(item.path)
    }
  }

  const [content, setContent] = useState('开通')
  useEffect(() => {
    if (localStorage.getItem('isVip') == 'true') {
      setContent('续费')
    } else {
      setContent('开通')
    }
  }, [])
  function handleToHome() {
    location.href = 'https://ias.zgbjds.com/'
  }

  function handleToImg(path) {
    history.push(path)
  }

  return (
    <div className={`${styles['sideNav']} ${styles[theme]}`}>
      <div className={styles['top']}>
        {/*logo*/}
        <div className={styles['topLogo']}>
          <Logo handleToHome={handleToHome}></Logo>
        </div>
        {/*导航1*/}
        <div className={styles['navList']}>
          {navList.map((item) => {
            return (
              <NavItem
                href={item.path}
                onClick={() => handleToPage(item)}
                isCurrent={item.path === location.pathname}
                key={item.title}
                icon={item.icon}
                title={item.title}></NavItem>
            )
          })}
        </div>
        {/*导航2*/}
        <div className={styles['navList']}>
          {navList2.map((item) => {
            return (
              <NavItem
                href={item.path}
                onClick={() => handleToPage(item)}
                isCurrent={item.path === location.pathname}
                key={item.title}
                icon={item.icon}
                title={item.title}></NavItem>
            )
          })}
        </div>
      </div>
      <div className={styles['bottom']}>
        {/*vip按钮*/}
        {/* <VipBtn onClick={handleToVip} content={content}></VipBtn> */}
        {/*导航3*/}
        <div className={styles['navList']}>
          {navList3.map((item) => {
            return (
              <NavItem
                href={item.path}
                onClick={() => {
                  window.open(item.path, '_blank')
                }}
                isCurrent={item.index === curIndex}
                key={item.title}
                icon={item.icon}
                title={item.title}></NavItem>
            )
          })}
        </div>
      </div>
    </div>
  )
}

export default SideNav
